import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types'

// Routing
import { Route, Switch, Redirect } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';

// Redux
import { connect } from 'react-redux';

// Pages
import Default from './Default';
import FeedPage from '../../pages/FeedPage';
import Notifications from '../../pages/Notifications/Notifications';
import Messages from '../../pages/Messages';
import ChatNav from '../../pages/ChatNav';
import SearchPage from '../../pages/SearchPage/SearchPage';
import School_SearchPage from '../../pages/SearchPage/School_SearchPage';
import LikePage from '../../pages/LikePage';
import Profile from '../../pages/Profile';
import EditProfile from '../../pages/EditProfile';
import Settings from '../../pages/Settings';
import SettingsNav from '../../pages/SettingsNav';
import PostPage from '../../pages/PostPage';
import LikedBy from '../../pages/LikedBy';
import BoostPage from '../../pages/BoostPost/BoostPage';
import StripeSuccessPage from '../../pages/BoostPost/StripeSuccessPage';
import StripeCancelPage from '../../pages/BoostPost/StripeCancelPage';
import MyAds from '../../pages/MyAds';
import MyAdsList from '../../pages/MyAdsList';
import GroupPage from '../../pages/GroupPage';
import EditGroup from '../../pages/EditGroup';
import GroupsPage from '../../pages/GroupsPage';
import CreateGroup from '../../pages/create/CreateGroup';
import FollowingPage from '../../pages/FollowingPage';
import DiscoverGroups from '../../pages/DiscoverGroups';
import AboutPage from '../../pages/AboutPage/AboutPage';
import MediaPage from '../../pages/MediaPage/MediaPage';
import SportsPage from '../../pages/SportsPage';
import FullSchedule from '../../pages/FullSchedule';
import GroupRequests from '../../pages/GroupRequests';
import CategoryPage from '../../pages/CategoryPage';
import CategoriesPage from '../../pages/CategoriesPage';
import PopularSearchesPage from '../../pages/PopularSearchesPage';
import MyCommentsPage from '../../pages/MyCommentsPage';
import ReviewPage from '../../pages/ReviewPage';
import MyReviewsPage from '../../pages/MyReviewsPage';

const Routes = ({ 
  auth: { 
    user, 
    isAuthenticated, 
    loading 
  },
  nav: {
    website,
    website_loading
  }
}) => {

  // Screen Width
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {

    // Add event listener for window resize
    window.addEventListener('resize', () => handleWindowSizeChange());
      
    // Clean up by removing event listener on component unmount
    return () => window.removeEventListener('resize', () => handleWindowSizeChange());
  }, [window.location]);

  // Handle window size change
  const handleWindowSizeChange = () => {
      setWindowWidth(window.innerWidth);
  };

  // Determine if the current screen width is mobile or tablet
  const isMobile = windowWidth <= 769;
  const isTablet = windowWidth <= 1000;

  return (
    <Fragment>
        <Switch>

            {/* Home page */}
            <Route exact path="/home" component={FeedPage} />
            <Route exact path="/groups" component={GroupsPage} />
            <Route exact path="/categories" component={CategoriesPage} />
            <Route exact path="/following" component={FollowingPage} />
            <Route exact path="/popular-searches" component={PopularSearchesPage} />
            <Route exact path="/photos" component={MediaPage} />
            <Route exact path="/about" component={AboutPage} />
            
            
            <Route exact path="/search" component={SearchPage} />
            <Route exact path="/search_schools" component={School_SearchPage} />

            {/* Notifications Page */}
            <Route exact path="/notifications" component={Notifications} />
            
            {/* Messages */}
            <Route exact path="/messages" component={!isTablet ? Messages : ChatNav} />
            <Route exact path="/messages" component={Messages} />

            <PrivateRoute exact path="/ads" component={!isTablet ? MyAds : MyAdsList} />

            <Route exact path="/saved" component={LikePage} />
            <Route exact path="/comments" component={MyCommentsPage} />
            <Route exact path="/my-reviews" component={MyReviewsPage} />
            <PrivateRoute exact path="/profile" component={Profile} />
            <PrivateRoute exact path="/profile/edit" component={EditProfile} />

            {/* Create Group */}
            <PrivateRoute exact path="/create/group" component={CreateGroup} />

            {/* Settings */}
            <Route exact path="/settings" component={SettingsNav}>

              {/* Redirect based on authentication and loading state */}
              {!isTablet && (
                !loading && isAuthenticated ? (
                  <Redirect to="/settings/account" /> 
                ) : (
                  <Redirect to="/settings/about" />
                )
              )}
            </Route>

            {/* Setting Account Pages */}
            <PrivateRoute exact path="/settings/account/screen_name" component={Settings} />
            <PrivateRoute exact path="/settings/account/password" component={Settings} />
            <PrivateRoute exact path="/settings/account/email" component={Settings} />
            <PrivateRoute exact path="/settings/account/verify_email" component={Settings} />
            {(!website_loading && !website) ? null : <PrivateRoute exact path="/settings/account/school_email" component={Settings} />}
            <PrivateRoute exact path="/settings/account/verify_school_email" component={Settings} />
            <PrivateRoute exact path="/settings/account/phone" component={Settings} />
            <PrivateRoute exact path="/settings/account/gender" component={Settings} />
            <PrivateRoute exact path="/settings/account/birth_date" component={Settings} />
            {/* End */}
            
            {/* More Settings Pages */}
            <PrivateRoute exact path="/settings/payments" component={Settings} />
            <PrivateRoute exact path="/settings/account" component={Settings} />
            <PrivateRoute exact path="/settings/activity" component={Settings} />
            <Route exact path="/settings/howitworks" component={Settings} />
            <Route exact path="/settings/about" component={Settings} />
            <Route exact path="/settings/help" component={Settings} />
            <Route exact path="/settings/feedback" component={Settings} />
            <Route exact path="/settings/returns" component={Settings} />
            <Route exact path="/settings/terms" component={Settings} />
            <Route exact path="/settings/trust_and_safety" component={Settings} />
            <Route exact path="/settings/privacy" component={Settings} />
            <Route exact path="/settings/cookies" component={Settings} />

            {/* Detail Post pages */}
            <Route exact path="/review/:id" component={ReviewPage} />
            <Route exact path="/post/:id" component={PostPage} />
            <Route exact path="/post/:id/likes" component={LikedBy} />
            <Route exact path="/post/:id/boost" component={BoostPage} />
            <Route exact path="/post/:id/boost/success" component={StripeSuccessPage} />
            <Route exact path="/post/:id/boost/cancel" component={StripeCancelPage} />

            {/* Category pages */}
            <Route exact path="/category/:url_handle" component={CategoryPage} />

            {/* ChatBox Page */}
            <PrivateRoute exact path="/messages/:id" component={Messages} />

            {/* Group Page */}
            <Route exact path="/groups/requests" component={GroupRequests} />
            <Route exact path="/groups/:id" component={GroupPage} />
            <PrivateRoute exact path="/groups/:id/edit" component={EditGroup} />

            {/* Discover Groups pages */}
            <Route exact path="/discover/:search_tag" component={DiscoverGroups} />

            {/* Sports Pages */}
            <Route exact path="/vs/:id" component={SportsPage} />
            <Route exact path="/schedule/:sport_type" component={FullSchedule} />

            {/* Ad Detail Page */}
            <PrivateRoute exact path="/ads/:adID" component={MyAds} />

            {/* Profile Page */}
            <Route exact path="/user/:id" component={Profile} />
            {/* <Route exact path="/:username" component={Profile} /> */}

            {/* Page not found */}
            <Route component={Default} />
        </Switch>
    </Fragment>
  );
};

Routes.propTypes = {
  auth: PropTypes.object.isRequired, // Object prop representing the authentication data for the user
  nav: PropTypes.object.isRequired
}

const mapStateToProps = state => ({

  // Mapping the states from the Redux store to the below props
  auth: state.auth,
  nav: state.nav
})

// Connect the SidebarMobile component to the Redux store and export it
export default connect(mapStateToProps, null)(Routes);
